export const SET_GOOGLE_API_KEY = 'SET_GOOGLE_API_KEY';
export const setGoogleApiKey = (apiKey) => ({
  type: SET_GOOGLE_API_KEY,
  payload: apiKey,
});
